<template>
    <div v-if="pageLoaded" class="resources__container" ref="scrollComponent" >
        <div class="filter__nav">
            <div class="search">
                <input category="text" placeholder="Buscar en Recursos" v-model="inputSearch" @keypress.enter="addSearchFilter" />
                <i @click.stop="addSearchFilter" class="material-icons">search</i>
            </div>
            <div class="filter__nav-filters">
                <template v-if="optionsLoaded">
                    <div  class="dropdown" ref="topic">
                        <input type="checkbox" id="topic">
                        <label class="dropdown__face" for="topic">
                            <div class="dropdown__text">{{ $t('resources.filters.TOPIC') }}</div>
                            <span class="material-icons">chevron_right</span>
                        </label>
                        <ul class="dropdown__items">
                            <template v-for="topic in options.topics" :key="topic.id" >
                                <li @click="filters.topics = topic.id; getResources(); hiddenItems('topic')" >{{ topic.name }}</li>
                            </template>
                        </ul>
                    </div>
                    <div  class="dropdown" ref="category" >
                        <input type="checkbox" id="category">
                        <label class="dropdown__face" for="category">
                            <div class="dropdown__text">{{$t('resources.filters.CATEGORY')}}</div>
                            <span class="material-icons">chevron_right</span>
                        </label>
                        <ul class="dropdown__items">
                            <template v-for="category in options.categories" :key="category.id" >
                                <li @click="filters.categories = category.id; getResources(); hiddenItems('category')" >{{ category.name }}</li>
                            </template>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
        <div v-if="optionsLoaded && (filters.topics || filters.categories || filters.search)" class="tags__container">
            <div v-if="filters.topics != undefined" class="tags__filter">{{options.topics.find(e => e.id === filters.topics).name}}<span  @click="filters.topics = undefined; getResources()" class="material-icons">close</span></div>
            <div v-if="filters.categories != undefined " class="tags__filter">{{options.categories.find(e => e.id === filters.categories).name}}<span  @click="filters.categories = undefined; getResources()" class="material-icons">close</span></div>
            <div v-if="filters.search != undefined " class="tags__filter">{{filters.search}}<span  @click="filters.search = undefined; getResources()" class="material-icons">close</span></div>
        </div>
        <template v-if="!filters.topics && !filters.categories && !filters.search" >
            <h3 v-if="lastResourcesViewed">{{$t('resources.titles.LAST_RESOURCES_VIEWED')}}</h3>
            <h3 v-else>{{ $t('resources.titles.HIGHLIGHTED_RESOURCES') }}</h3>
            <div class="resources__cardsContainer--lastOrRecommended">
                <template v-if="!resourcesRecommendedLoaded" >
                    <ResourceCard :loader="resourcesRecommendedLoaded" />
                    <ResourceCard :loader="resourcesRecommendedLoaded" />
                    <ResourceCard :loader="resourcesRecommendedLoaded" />
                </template>
                <template v-for="resource in resourcesRecommended" :key="resource.id" >
                    <ResourceCard :resource="resource" :loader="resourcesRecommendedLoaded" />
                </template>
            </div>
        </template>
        <h3 v-if="!filters.topics && !filters.categories && !filters.search">{{$t('resources.titles.NEW_RESOURCES')}}</h3>
        <template v-else-if="moreResourcesLoaded">
            <h3 >{{$t('resources.titles.FILTERED_RESOURCES')}}</h3>
            <EmptyState v-if="resourcesLoaded && !resources?.data?.length" :type="'search'" :message="filters.search" />
        </template>
        <div class="resources__cardsContainer">
            <template v-if="!resourcesLoaded && !moreResourcesLoaded">
                <ResourceCard :loader="resourcesLoaded" />
                <ResourceCard :loader="resourcesLoaded" />
                <ResourceCard :loader="resourcesLoaded" />
            </template>
            <template v-else v-for="resource in resources.data" :key="resource.id" >
                <ResourceCard :resource="resource" :loader="resourcesLoaded"  />
            </template>
            <ResourceCard v-if="!moreResourcesLoaded" :loader="moreResourcesLoaded" />
        </div>
    </div>


    <!-- INICIO MODAL -->

    <Modal v-if="resourceFromLink" :isOpen="modalIsOpen" @close="closeModal" @keyup.esc="closeModal" >
        <div class="modal__content">
            <h1>{{ resourceFromLink.name }}</h1>
            <div v-html="resourceFromLink.data.Data" ></div>
            <p>{{ resourceFromLink.description }}</p>
        </div>
    </Modal>

    <!-- FIN MODAL -->

</template>

<script>
    import ResourceCard from '../components/ResourceCard.vue'
    import { useStore } from 'vuex';
    import {  ref, computed } from 'vue'
    import { onMounted, onUnmounted } from 'vue-demi'
    import { onClickOutside } from '@vueuse/core'
    import EmptyState from '../components/EmptyState.vue';
    import Modal from '../components/Modal.vue'
    import { useRoute } from 'vue-router';
import router from '../router';
    export default{
        components: {
    ResourceCard,
    EmptyState,
    Modal
},
        setup(){
            const store = useStore();
            const route = useRoute();
            const resources = ref([]);
            const resourcesLoaded = ref(false);
            const resourcesRecommended = ref();
            const resourcesRecommendedLoaded = ref(false)
            const lastResourcesViewed = ref(false)
            const moreResourcesLoaded = ref(true)
            const options = ref()
            const user = computed(() => store.getters.manageUser_user);
            const optionsLoaded = ref(false)
            const inputSearch = ref('')
            const filters = ref({
                page: 0,
                rowsPerPage: 12,
                topics: undefined,
                categories: undefined,
                search: undefined
            })
            const topic = ref(null)
            const category = ref(null)
            const remindResults = ref(0)
            const scrollComponent = ref(null)
            const resourceFromLink = ref()
            const modalIsOpen = ref(false)
            const pageLoaded = ref(false)

            const getOptions = async () => {
                let res = await store.dispatch("resources_options")
                options.value = res.data
                optionsLoaded.value = true
            }

            const getResources = async (infinite=false) => {
                
                if(!infinite) filters.value.page = 0
                else {
                    moreResourcesLoaded.value = false
                    filters.value.page++
                    let res2 = await store.dispatch('resources', filters.value)
                    res2.data.data.forEach(r => r.data = JSON.parse(r.data))
                    resources.value.data.push(...res2.data.data)
                    moreResourcesLoaded.value = true
                    remindResults.value += res2.data.data.length
                    return
                }
                filters.value.page = 0
                resourcesLoaded.value = false
                resourcesRecommendedLoaded.value = false
                remindResults.value = 0
                let res1 = await store.dispatch("resources_lastOrRecommended", 4)
                let res2 = await store.dispatch('resources', filters.value)
                resourcesRecommended.value = res1.data.resources
                lastResourcesViewed.value = res1.data.seenByUser
                resources.value = res2.data

                resourcesRecommended.value.forEach( r => r.data = JSON.parse(r.data))
                resources.value.data.forEach(r => r.data = JSON.parse(r.data))

                remindResults.value += res2.data.data.length


                resourcesRecommendedLoaded.value = true
                resourcesLoaded.value = true
            }

            const handleScroll = () => {
                if(moreResourcesLoaded.value){
                    let element = scrollComponent.value
                    if(element.getBoundingClientRect().bottom - 1 < window.innerHeight){
                        (resources.value.totalResults - remindResults.value ) > 0 && getResources(true)
                    }
                }
            }


            const addSearchFilter = () => {
                if(inputSearch.value.trim().length <= 1) {inputSearch.value = undefined; return}
                filters.value.search = inputSearch.value
                getResources()
            }

            const hiddenItems = (id) => {
                document.getElementById(id).checked = false
            }

            const getResourceById = async () => {
                try{
                    let { data } = await store.dispatch('resource_byId',route.params.resourceId)
                    resourceFromLink.value = data
                    resourceFromLink.value.data = JSON.parse(resourceFromLink.value.data)
                }
                catch{
                    router.replace('/resources')
                }
            }

            const closeModal = () =>{
                modalIsOpen.value = false
                router.replace('/resources')
            }

            onClickOutside(topic, () => hiddenItems('topic'))
            onClickOutside(category, () => hiddenItems('category'))

            onMounted(() => {
                if (!user.value?.permissions?.includes('RECURSO_VISUALIZACION')) router.replace('/login')
                pageLoaded.value = true
                getOptions()
                getResources()
                if(route.params.resourceId){     
                    getResourceById()
                    modalIsOpen.value = true    // Si es un link de un recurso, se abrira el modal con el mismo
                }
                window.addEventListener('scroll', handleScroll)
            })

            onUnmounted(() => {
                window.removeEventListener('scroll', handleScroll)
            })

            return {
                resources,
                pageLoaded,
                resourcesLoaded,
                resourcesRecommended,
                resourcesRecommendedLoaded,
                lastResourcesViewed,
                scrollComponent,
                moreResourcesLoaded,
                options,
                optionsLoaded,
                filters,
                resourceFromLink,
                addSearchFilter,
                getResources,
                remindResults,
                inputSearch,
                hiddenItems,
                topic,
                category,
                closeModal,
                modalIsOpen
            }
        }
    }
</script>

<style lang="scss">
@import "@/styles/main.scss";

.modal__content{
    display: flex;
    flex-direction: column;
    width: 691px;
    iframe{
        width: 100%;
        //height: 400px;
    }
    h1{
        font-weight: 600;
        font-size: 22px;
        color: #404248;
        margin: 24px;
        @media screen and (max-width: $bpMedium) {
            margin: 0;
            margin-bottom: 24px;
            font-size: 16px;
            align-self: flex-start;
        }
    }
    p{
        font-size: 12px;
        font-weight: 400;
        color: $black;
        margin: 24px auto;
        width: 70%;
        @media screen and (max-width: $bpMedium) {
            margin: 12px 0;
            width: 100%;
        }
    }
}

.resources__container{
    margin: 0 auto;
    width: 1328px;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: flex-start;
    @media screen and (max-width: 1400px){
        width: 992px;
    }
    @media screen and (max-width: 1100px){
        width: 656px;
    }
    @media screen and (max-width: 700px){
        width: 98%;
    }
    h3 {
        font-size: 24px;
        font-weight: 700;
        color: $black;
        margin: 22px 0;
        @media screen and (max-width: $bpSmall){
            font-size: 15px;
            padding-left: 12px;
        }   
    }

    .tags__container{
        margin: 16px;
        .tags__filter{
            display: inline-flex;
            align-items: center;
            margin: 5px 6px;
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
            color: $black;
            border-radius: 999px;
            background-color: rgba($color: $black, $alpha: .1);
            padding: 8px 16px;
            .material-icons{
                font-size: 13px;
                margin-left: 5px;
                cursor: pointer;
            }
        }
    }


    .filter__nav{
        .filter__nav-filters{
            display: flex;
            gap: 20px;
            
            button{
                height: 100%;
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 0 12px;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: $black;
            }
        }
    }
}

@media screen and (min-width: $bpBig){
    .resources__cardsContainer, .resources__cardsContainer--lastOrRecommended{
            display: grid;
            grid-template-columns: repeat(auto-fill, 320px);
            gap: 16px;
    }
    .filter__nav{
        display:flex;
        justify-content: space-between;
        align-content: center;
        margin-top: 9px;
    }
}

@media screen and (max-width: $bpBig){
    .resources__cardsContainer{
        display: grid;
        grid-template-columns: repeat(auto-fill, 320px);
        gap: 16px;
        &--lastOrRecommended{
            display: flex;
            gap: 16px;
            flex-wrap: nowrap;
            overflow-x: scroll;
            padding-bottom: 24px;
        }
    }

    .filter__nav{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }
}

@media screen and (min-width: $bpBig) and (max-width: 1400px){
    .resourceCard:last-child{
        display: none;
    }
}
@media screen and (min-width: $bpSmall) and (max-width: $bpBig){
    .resources__cardsContainer{
        .resourceCard:last-child, .resourceCard:nth-child(3){
            display: none;
        }
    }
}
@media screen and (max-width: $bpSmall){
    .resources__container{
        padding-left: 6px;
        padding-right: 6px;
    }
    .resources__cardsContainer{
        margin: 0 auto;
    }
}
</style>